module.exports = __webpack_public_path__ + "static/media/fitness_email.2945a647.avif";